import { create } from 'zustand';
import { Course, CourseVideo } from '../types';

interface CoursesState {
  courses: Course[];
  currentCourse: Course | null;
  courseVideos: CourseVideo[];
  hasAccess: boolean;
  isLoading: boolean;
  error: string | null;
  
  // Actions
  fetchCourses: () => Promise<void>;
  fetchCourse: (courseId: number) => Promise<void>;
  clearCurrentCourse: () => void;
  clearError: () => void;
}

const API_BASE = 'https://course-platform-api.fedacreativity.workers.dev';

export const useCoursesStore = create<CoursesState>((set, get) => ({
  courses: [],
  currentCourse: null,
  courseVideos: [],
  hasAccess: false,
  isLoading: false,
  error: null,

  fetchCourses: async () => {
    set({ isLoading: true, error: null });
    
    try {
      const response = await fetch(`${API_BASE}/api/courses`);
      
      if (!response.ok) {
        throw new Error('فشل في جلب قائمة الكورسات');
      }
      
      const data = await response.json();
      set({ 
        courses: data.courses || [],
        isLoading: false 
      });
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'حدث خطأ غير متوقع',
        isLoading: false 
      });
    }
  },

  fetchCourse: async (courseId: number) => {
    set({ isLoading: true, error: null });
    
    try {
      const response = await fetch(`${API_BASE}/api/course/${courseId}`);
      
      if (!response.ok) {
        throw new Error('فشل في جلب تفاصيل الكورس');
      }
      
      const data = await response.json();
      set({ 
        currentCourse: data.course,
        courseVideos: data.videos || [],
        hasAccess: data.has_access || false,
        isLoading: false 
      });
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'حدث خطأ غير متوقع',
        isLoading: false 
      });
    }
  },

  clearCurrentCourse: () => {
    set({ 
      currentCourse: null, 
      courseVideos: [], 
      hasAccess: false 
    });
  },

  clearError: () => {
    set({ error: null });
  },
}));